import React, { useEffect, useState } from "react";
import { Button, Col, Row } from "reactstrap";
import Sidebar from "../../SideBar";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import {
  ListReportIssues,
  UpdateReportStatus,
} from "../../../components/Header/Data3";
import { useSelector } from "react-redux";
import { FadeLoader } from "react-spinners";

const ReportManagement = () => {
  const islogin = useSelector((state) => state.user.isLogin);
  const userinfo = useSelector((state) => state.user.userInfo);
  const user = islogin ? JSON.parse(userinfo) : null;
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchListReportIssues = async () => {
    const respose = await ListReportIssues();
    console.log(respose, "ReportManagement");
    setRows(respose);
  };

  useEffect(() => {
    setLoading(true);
    fetchListReportIssues();
    setLoading(false);
  }, []);

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));
  console.log(rows, "loading");

  const handleReviewClick = async (row) => {
    console.log(row);
    let formData = {
      Id: row.Id,
      messageId: row.messageId,
      reportStatus: "In-Progress",
      updatedBy: user.UserID,
    };

    await UpdateReportStatus(formData);
    fetchListReportIssues();
  };
  const handleResolveClick = async (row) => {
    let formData = {
      Id: row.Id,
      messageId: row.messageId,
      reportStatus: "Completed",
      updatedBy: user.UserID,
    };

    await UpdateReportStatus(formData);
    fetchListReportIssues();
  };

  const handleRejectClick = async (row) => {
    let formData = {
      Id: row.Id,
      messageId: row.messageId,
      reportStatus: "Rejected",
      updatedBy: user.UserID,
    };
    await UpdateReportStatus(formData);
    fetchListReportIssues();
  };

  return (
    <section className="home-after-login bg-white ">
      <div className="container">
        <Row>
          <Col sm={4} lg={3}>
            <Sidebar />
          </Col>
          <Col sm={8} lg={9} className="requests-container position-relative">
            {loading ? (
              <FadeLoader // FadeLoader component
                color={"#36D7B7"}
                loading={loading}
                style={{ top: "30%" }}
                className="position-absolute translate-middle start-50"
              />
            ) : (
              <>
                <h3 className="text-center my-3">Report Issue Management</h3>
                <TableContainer
                  component={Paper}
                  sx={{
                    overflowX: "scroll",
                    overflowY: "scroll",
                    height: "1110px",
                  }}
                >
                  <Table
                    sx={{ overflowX: "scroll" }}
                    stickyHeader
                    aria-label="sticky table"
                  >
                    <TableHead>
                      <TableRow>
                        <StyledTableCell>Reported By</StyledTableCell>
                        <StyledTableCell>Reported Entity</StyledTableCell>
                        <StyledTableCell>Reason for Report</StyledTableCell>
                        <StyledTableCell>Status </StyledTableCell>
                        <StyledTableCell align="center">
                          Actions
                        </StyledTableCell>
                      </TableRow>
                    </TableHead>
                    {rows.length !== 0 ? (
                      <TableBody className="">
                        {rows.map((row) => (
                          <StyledTableRow
                            key={row.Id}
                            sx={{
                              "&:last-child td, &:last-child th": {
                                border: 0,
                              },
                            }}
                          >
                            <StyledTableCell component="th" scope="row">
                              {row.reportedBy}
                            </StyledTableCell>
                            <StyledTableCell>
                              {row.reportedEntity}
                            </StyledTableCell>
                            <StyledTableCell>
                              {row.reason === "Other"
                                ? row.comment
                                : row.reason}
                            </StyledTableCell>
                            <StyledTableCell>
                              {row.reportStatus}
                            </StyledTableCell>
                            <StyledTableCell>
                              <div className="d-flex align-items-center justify-content-center gap-2">
                                {row.reportStatus === "Pending" ? (
                                  <Button
                                    variant="contained"
                                    color="primary"
                                    className="mr-2 text-nowrap"
                                    size="sm"
                                    onClick={() => handleReviewClick(row)}
                                  >
                                    Mark as Reviewed{" "}
                                  </Button>
                                ) : row.reportStatus === "In-Progress" ? (
                                  <>
                                    <Button
                                      variant="contained"
                                      color="success"
                                      size="sm"
                                      className="mr-2 text-nowrap"
                                      onClick={() => handleResolveClick(row)}
                                    >
                                      Resolve Issue
                                    </Button>
                                    <Button
                                      variant="contained"
                                      color="danger"
                                      size="sm"
                                      className="mr-2"
                                      onClick={() => handleRejectClick(row)}
                                      // disabled={row.reportStatus === "Rejected"}
                                    >
                                      Reject
                                    </Button>
                                  </>
                                ) : (
                                  <Button
                                    variant="contained"
                                    color={
                                      row.reportStatus === "Rejected"
                                        ? "danger"
                                        : "success"
                                    }
                                    size="sm"
                                    className="mr-2"
                                    disabled={
                                      row.reportStatus === "Rejected" ||
                                      row.reportStatus === "Completed"
                                    }
                                  >
                                    {row.reportStatus === "Rejected"
                                      ? "Rejected"
                                      : "Resolved"}
                                  </Button>
                                )}
                              </div>
                            </StyledTableCell>
                          </StyledTableRow>
                        ))}
                      </TableBody>
                    ) : (
                      <TableBody className="">
                        <StyledTableRow colSpan={5}>
                          <StyledTableCell
                            colSpan={5}
                            align="center"
                            style={{ fontSize: "larger" }}
                          >
                            No Reports Found
                          </StyledTableCell>
                        </StyledTableRow>
                      </TableBody>
                    )}
                  </Table>
                </TableContainer>
              </>
            )}
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default ReportManagement;
